function mountSiteHeader(): void {
  document.querySelectorAll<HTMLElement>("[data-site-header]").forEach((header) => {
    const navToggle = header.querySelector<HTMLButtonElement>("[data-site-nav-toggle]")
    const navMenu = header.querySelector<HTMLElement>("[data-site-nav-menu]")

    if (navToggle && navMenu) {
      mountToggleMenu({
        root: header,
        toggle: navToggle,
        menu: navMenu,
        isOpen: () => navMenu.classList.contains("is-open"),
        setOpen: (open) => {
          navMenu.classList.toggle("is-open", open)
          navToggle.setAttribute("aria-expanded", open ? "true" : "false")
        },
      })
    }

    header.querySelectorAll<HTMLElement>("[data-user-menu]").forEach((menuRoot) => {
      const toggle = menuRoot.querySelector<HTMLButtonElement>("[data-user-menu-toggle]")
      const menu = menuRoot.querySelector<HTMLElement>("[data-user-menu-dropdown]")
      if (!toggle || !menu) return

      mountToggleMenu({
        root: menuRoot,
        toggle,
        menu,
        isOpen: () => !menu.hidden,
        setOpen: (open) => {
          menu.hidden = !open
          toggle.setAttribute("aria-expanded", open ? "true" : "false")
        },
      })
    })
  })
}

type ToggleMenu = {
  root: HTMLElement
  toggle: HTMLButtonElement
  menu: HTMLElement
  isOpen: () => boolean
  setOpen: (open: boolean) => void
}

function mountToggleMenu({ root, toggle, isOpen, setOpen }: ToggleMenu): void {
  toggle.addEventListener("click", (event) => {
    event.preventDefault()
    setOpen(!isOpen())
  })

  document.addEventListener("click", (event) => {
    if (!isOpen()) return
    if (event.target instanceof Node && !root.contains(event.target)) {
      setOpen(false)
    }
  })

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || !isOpen()) return
    setOpen(false)
    toggle.focus()
  })
}

mountSiteHeader()
